import { StoryblokComponent, storyblokEditable } from "@storyblok/react";
import { MegaMediaBannerModel } from "./MegaMediaBannerModel";

import "./MegaMediaBanner.css";
import Utils from "../../core/Utils/Utils";

const MegaMediaBanner: React.FC<{ blok: MegaMediaBannerModel }> = ({
  blok,
}) => {
  const isVideo = blok.media?.filename?.endsWith(".mp4");

  return (
    <div {...storyblokEditable(blok)} className="mega-media-banner">
      {isVideo && (
        <video
          autoPlay
          loop
          muted
          playsInline
          src={Utils.getCacheUrl(blok.media?.filename)}
          data-object-fit="cover"
          onError={(e) => Utils.handleVideoError(e, blok.media.filename)}
        ></video>
      )}
      {!isVideo && blok.media?.filename && (
        <img
          src={Utils.getCacheUrl(blok.media.filename)}
          alt=""
          onError={(e) => Utils.handleImageError(e, blok.media.filename)}
        />
      )}

      <div className="container">
        <div className="title" style={{ color: blok.textColor }}>
          {blok.text}
        </div>
        <div className="subtitle" style={{ color: blok.subTextColor }}>
          {blok.subText}
        </div>
        <div className="action-area">
          {blok.buttons
            ? blok.buttons.map((button) => (
                <StoryblokComponent
                  blok={button}
                  key={button._uid}
                  className="button"
                />
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

export default MegaMediaBanner;
